<!--The purpose of this component is to directly upload attachments to ServiceNow, and bypass EH integration layer-->
<template>
  <div>

    <div>
      <header-with-tooltip
          :tooltip-text="CONSTANTS.ATTACH_DOCUMENT_TOOLTIP">
        {{CONSTANTS.ATTACH_A_SUPPORTING_DOC}}
      </header-with-tooltip>
      <div class="font-italic">Maximum file size allowed: {{ maxFileSizeInMB }} (in total)</div>
    </div>


    <div class="fr-popup fr-desktop fr-active file-upload">
      <div
          class="fr-file-upload-layer fr-layer fr-active"
          style="width: 100%;"
          :class="{'drag-over': draggingFileOver}"
          @dragover="draggingFileOver=true"
          @dragleave="draggingFileOver=false"
      >
        <strong>Drop file</strong>
        <br>(or click)
        <div class="fr-form">
          <input
              @change="onFileInserted($event)"
              type="file"
              name="file"
              :accept="validFileTypes"
              tabindex="-1"
              aria-labelledby="fr-file-upload-layer-6"
              role="button"
              dir="auto"
              ref="fileUploader"
              @click="resetFileUploader"
              @dragover.prevent
              @drop.prevent="onDrop"
          >
        </div>
      </div>
      <div class="text-danger input-error-text" v-if="errorMessage">{{errorMessage}}</div>
    </div>
    <attachments-viewer class="pt-3" :attachments="attachments" :is-preview-mode="false" @onFileDeleted="onFileDeleted($event)"  />
  </div>
</template>

<script>
import AttachmentsViewer from "@/components/Payments/AttachmentsViewer";
import HeaderWithTooltip from "@/components/HeaderWithTooltip";
import CONSTANTS from "@/store/constants";

export default {
  name: "ServiceNowAttachments",
  props: ["existingFiles", "maxFileSizeInMB","validFileTypes"],
  components: {HeaderWithTooltip, AttachmentsViewer},
  data(){
    return {
      draggingFileOver: false,
      errorMessage: null,
      totalFilesSize: 0,
      attachments: [],
      maxFileSizeInBytes: parseFloat(this.maxFileSizeInMB) * 1024 * 1024
    }
  },
  mounted() {
    if(this.existingFiles) {
      this.attachments = this.existingFiles
    }
  },
  methods: {
    onFileInserted(event) {
      this.errorMessage = null;
      let fileObj = event.currentTarget.files[0]
      let file = event.currentTarget.files[0]
      this.updateAttachments(fileObj, file)
    },
    onDrop(event) {
      this.errorMessage = null;
      this.draggingFileOver = false;
      let fileObj = event.dataTransfer.files[0]
      let file = event.dataTransfer.files[0]
      this.updateAttachments(fileObj, file)
    },
    resetFileUploader() {
      this.$refs.fileUploader.value = "";
    },
    isFileSizeInvalid(currentFileSize) {
      let existingFilesSize = 0
      if(this.existingFiles && this.existingFiles.length > 0) {
        this.existingFiles.forEach(file => {
          existingFilesSize += parseFloat(file.fileSize)
        })
      }
      return existingFilesSize + parseFloat(currentFileSize) > parseFloat(this.maxFileSizeInBytes)
    },
    isInvalidFileExtension(file) {
      let extension =  file.name.split('.').pop();
      return !this.validFileTypes.includes(extension.toLowerCase())
    },
    isFileSizeZero(file){
      return file.size === 0
    },
    fileNameExist(file) {
      let newFileName = file.name
      let existingFileNames = []
      this.existingFiles.forEach(file => {
        existingFileNames.push(file.fileName)
      })
      return existingFileNames.some((fileName) => newFileName === fileName)
    },
    isFileNameExceedingAllowedLength(file) {
      return file.name.length > 50
    },
    updateAttachments(fileObj, file) {
      if(this.validationErrors(fileObj)) return
      this.attachments.push({
        fileId: fileObj.name,
        fileName: fileObj.name,
        fileSize: fileObj.size,
        file: file
      })
      this.existingFiles = this.attachments
      this.$emit('onAttachmentAdded',this.attachments)
    },
    validationErrors(fileObj) {
      if(this.isFileSizeInvalid(fileObj.size)) {
        this.errorMessage = CONSTANTS.ATTACHMENT_VALIDATION_ERROR_MESSAGE.FILE_SIZE_EXCEEDED_ERROR
        return true
      }
      if(this.fileNameExist(fileObj)) {
        this.errorMessage = CONSTANTS.ATTACHMENT_VALIDATION_ERROR_MESSAGE.ALREADY_EXIST_ERROR
        return true
      }
      if (this.isFileSizeZero(fileObj)){
        this.errorMessage = CONSTANTS.ATTACHMENT_VALIDATION_ERROR_MESSAGE.ZERO_KB_ERROR
        return true
      }
      if (this.isFileNameExceedingAllowedLength(fileObj)){
        this.errorMessage = CONSTANTS.ATTACHMENT_VALIDATION_ERROR_MESSAGE.FILE_NAME_50_CHAR_ERROR
        return true
      }
      if(this.isInvalidFileExtension(fileObj)) {
        this.errorMessage = CONSTANTS.ATTACHMENT_VALIDATION_ERROR_MESSAGE.INVALID_FILE_EXTENSION_ERROR + this.validFileTypes
        return true
      }
      return false
    },
    onFileDeleted(fileAttachment) {
      let updatedAttachments = this.attachments.filter(attachment => attachment.fileId !== fileAttachment.fileId)
      this.attachments = updatedAttachments
      this.$emit('onAttachmentAdded',this.attachments)
    }
  }
}
</script>

<style scoped>
.file-upload {
  border-top: 0;
  box-shadow: none;
  -webkit-box-shadow: none;
}
.fr-popup {
  position: relative;
  font-family: artifaktElementRegular;
  z-index: 0 !important;
  margin: 0;
}
.fr-popup .fr-layer {
  margin: 0;
  margin-bottom: 1em;
}
.fr-popup .fr-file-upload-layer.drag-over {
  background: #ebebeb !important;
}
.loading-overlay {
  opacity: 0.5;
  background-color: #f5f5f5;
  z-index: 10;
}
</style>